import React from "react";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopType from "@/enum/ShopType";
import OrderMark from "../../column/OrderMark";
import OrderOriginalIdInfo from "./OrderOriginalIdInfo";
import OrderPaymentSummary from "./OrderPaymentSummary";
import BuyerRemarks from "./BuyerRemarks";
import SellerRemarks from "./SellerRemarks";
import { getOrderShippingDeadlineText } from "@/utils/OrderUtils";

interface OrderBasicInfoProps {
    order: OrderDTO;
    isShowRemarks: boolean;
    shopType?: ShopType;
}

/**
 * 订单基础信息
 */
const OrderBasicInfo: React.FC<OrderBasicInfoProps> = observer(function (props) {
    const { order, isShowRemarks, shopType } = props;

    return (
        <tr key={`info${order.id}`}>
            <td colSpan={5}>
                <p className="order-info">
                    <OrderOriginalIdInfo order={order} shopType={shopType} />
                    <span>下单: {order.orderTime}</span>
                    {order.paymentTime ? <span>付款: {order.paymentTime}</span> : null}
                    {order.shippingTime ? <span>发货:{order.shippingTime}</span> : null}
                    <OrderPaymentSummary order={order} />
                    {order.shippingDeadline ? (
                        <span>
                            {getOrderShippingDeadlineText(shopType)}:{order.shippingDeadline}
                        </span>
                    ) : null}
                    {order.taobaoOrderExtraInfo?.superLinkOrder?.superlinkPlatformOrderId ? (
                        <span>超链订单编号:{order.taobaoOrderExtraInfo.superLinkOrder.superlinkPlatformOrderId}</span>
                    ) : null}

                    {order.taobaoOrderExtraInfo?.superLinkOrder?.superlinkPayment ? (
                        <span>超链实付:{order.taobaoOrderExtraInfo.superLinkOrder.superlinkPayment}元</span>
                    ) : null}
                </p>

                {isShowRemarks ? <BuyerRemarks order={order} /> : null}

                {isShowRemarks ? <SellerRemarks order={order} /> : null}

                {isShowRemarks && order?.markId ? (
                    <div className="order-mark-container">
                        <span>标记：</span>
                        <OrderMark id={order.markId} className="inline-block" />
                    </div>
                ) : null}
            </td>
        </tr>
    );
});

export default OrderBasicInfo;
